import { useRef, useState, useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import './CategoryCarousel.css';

const defaultCategories = [
  { id: 1, image: '/imagenes/cat-gastronomia.jpg', subtitle: 'Restaurantes', title: 'GASTRONOMIA', buttonText: 'Ver mas', link: '/categoria/gastronomia' },
  { id: 2, image: '/imagenes/cat-spa.jpg', subtitle: 'Bienestar', title: 'BELLEZA Y SPA', buttonText: 'Ver mas', link: '/categoria/belleza-y-spa' },
  { id: 3, image: '/imagenes/cat-viajes.jpg', subtitle: 'Hoteles', title: 'VIAJES', buttonText: 'Ver mas', link: '/categoria/viajes-y-hoteles' },
  { id: 4, image: '/imagenes/cat-cursos.jpg', subtitle: 'Aprende', title: 'CURSOS', buttonText: 'Ver mas', link: '/categoria/cursos' },
];

export default function CategoryCarousel() {
  const trackRef = useRef(null);
  const { data: carouselData } = useQuery({
    queryKey: ['heroCarousel'],
    queryFn: async () => {
      const res = await fetch('/api/homepage').then(r => r.json());
      if (res.exito && res.datos.carousel?.length > 0) {
        return res.datos.carousel.map((c, i) => ({
          id: i + 1, image: c.image_url, subtitle: '', title: c.title || '', buttonText: 'Ver mas', link: c.link || '#',
        }));
      }
      return null;
    },
    staleTime: 60 * 1000,
  });

  const categories = carouselData || defaultCategories;
  const [replicas, setReplicas] = useState(2);

  const handleScroll = () => {
    if (!trackRef.current) return;
    const { scrollLeft, scrollWidth, clientWidth } = trackRef.current;
    if (scrollWidth - (scrollLeft + clientWidth) < 500) setReplicas(r => r + 1);
  };

  const scrollLeftBtn = () => trackRef.current?.scrollBy({ left: -300, behavior: 'smooth' });
  const scrollRightBtn = () => trackRef.current?.scrollBy({ left: 300, behavior: 'smooth' });

  useEffect(() => {
    const interval = setInterval(() => {
      if (window.innerWidth <= 1024) scrollRightBtn();
    }, 7000);
    return () => clearInterval(interval);
  }, []);

  const displayCategories = Array(replicas).fill(categories).flat();

  return (
    <section className="category-carousel-section">
      <h2 className="category-carousel-title">EXPLORA POR CATEGORIA</h2>
      <div className="category-carousel-container">
        <button className="carousel-nav-btn prev" aria-label="Anterior" onClick={scrollLeftBtn}>
          <svg viewBox="0 0 24 24" fill="none"><path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
        </button>

        <div className="category-carousel-track" ref={trackRef} onScroll={handleScroll}>
          {displayCategories.map((category, index) => (
            <a key={`${category.id}-${index}`} href={category.link} className="category-card" style={{ textDecoration: 'none' }}>
              <img src={category.image} alt={category.title || category.buttonText} className="category-card-bg" width="350" height="480" loading={index < 4 ? 'eager' : 'lazy'} />
              <div className="category-card-content">
                <div className="category-card-text">
                  {category.subtitle && <span className="category-subtitle">{category.subtitle}</span>}
                  {category.title && <h3 className="category-title">{category.title}</h3>}
                </div>
                <span className="category-btn">{category.buttonText}</span>
              </div>
            </a>
          ))}
        </div>

        <button className="carousel-nav-btn next" aria-label="Siguiente" onClick={scrollRightBtn}>
          <svg viewBox="0 0 24 24" fill="none"><path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
        </button>
      </div>
    </section>
  );
}
